import React from 'react';
import { useTranslation } from 'react-i18next';

const InventoryLowStock = ({ data }) => {
    const { t } = useTranslation();
    if (!data || !data.products || data.products.length === 0) return null;

    const products = data.products;
    const maxShortage = Math.max(...products.map(p => parseFloat(p.shortage) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{t('inventoryAnalytics.charts.lowStock.title')}</span>
                    <div style={subtitleStyle}>{t('inventoryAnalytics.charts.lowStock.subtitle')}</div>
                </div>
                <span style={badgeStyle}>{t('inventoryAnalytics.charts.lowStock.itemsCount', { count: data.total_low_stock })}</span>
            </div>
            <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 750 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <th style={thStyle('left')}>{t('inventoryAnalytics.charts.lowStock.headers.product')}</th>
                            <th style={thStyle('left')}>{t('inventoryAnalytics.charts.lowStock.headers.warehouse')}</th>
                            <th style={thStyle('right')}>{t('inventoryAnalytics.charts.lowStock.headers.stock')}</th>
                            <th style={thStyle('right')}>{t('inventoryAnalytics.charts.lowStock.headers.minimum')}</th>
                            <th style={thStyle('right')}>{t('inventoryAnalytics.charts.lowStock.headers.shortage')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((p, i) => {
                            const shortage = parseFloat(p.shortage) || 0;
                            const pct = maxShortage > 0 ? (shortage / maxShortage) * 100 : 0;
                            return (
                                <tr
                                    key={i}
                                    style={{ borderBottom: '1px solid #f9fafb' }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#fef2f2'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <td style={{ ...tdStyle, maxWidth: 180 }}>
                                        <div style={{ fontWeight: 600, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                            title={p.product_name}>
                                            {p.product_name}
                                        </div>
                                        {p.alias_name && (
                                            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{p.alias_name}</div>
                                        )}
                                        {p.category_name && (
                                            <span style={{ fontSize: 10, fontWeight: 600, color: '#7c3aed', backgroundColor: '#f5f3ff', borderRadius: 10, padding: '1px 6px', display: 'inline-block', marginTop: 2 }}>
                                                {p.category_name}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ ...tdStyle, color: '#6b7280', fontSize: 12 }}>{p.warehouse_name}</td>
                                    <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 700, color: parseInt(p.stock_quantity) < 0 ? '#ef4444' : '#111827' }}>
                                        {parseInt(p.stock_quantity).toLocaleString('en-IN')}
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right', color: '#6b7280' }}>
                                        {parseInt(p.minimum_stock).toLocaleString('en-IN')}
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right' }}>
                                        <div style={{ fontWeight: 700, color: '#dc2626' }}>
                                            {shortage.toLocaleString('en-IN')}
                                        </div>
                                        <div style={{ height: 3, borderRadius: 2, backgroundColor: '#fee2e2', marginTop: 4, width: '100%', minWidth: 50 }}>
                                            <div style={{ height: '100%', borderRadius: 2, backgroundColor: '#ef4444', width: `${pct}%` }} />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    overflow: 'hidden',
};
const headerStyle = {
    padding: '18px 20px 12px',
    borderBottom: '1px solid #f9fafb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
};
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = {
    fontSize: 11, fontWeight: 700, color: '#dc2626',
    backgroundColor: '#fef2f2', borderRadius: 20, padding: '3px 10px',
};
const thStyle = (align) => ({
    padding: '10px 16px',
    textAlign: align,
    fontSize: 11,
    fontWeight: 700,
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: '#fafafa',
    whiteSpace: 'nowrap',
});
const tdStyle = { padding: '10px 16px', verticalAlign: 'middle' };

export default InventoryLowStock;
